export const helmet = {
    title: "Publisher portal",
    metaTags: [
        { name: "description", content: "A dapp which assists the user to publish his service" },
    ],
};
